function NotFound() {
    return (
        <>
       
          <h1 style = {{textAlign : 'center'}}>Page not exist</h1>
        </>
    )
  }
  
  export default NotFound;